import { render, staticRenderFns } from "./TipTap.vue?vue&type=template&id=0814711c&scoped=true"
import script from "./TipTap.vue?vue&type=script&lang=js"
export * from "./TipTap.vue?vue&type=script&lang=js"
import style0 from "./TipTap.vue?vue&type=style&index=0&id=0814711c&prod&scoped=true&lang=css"
import style1 from "./TipTap.vue?vue&type=style&index=1&id=0814711c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814711c",
  null
  
)

export default component.exports